import React, { useEffect, useState } from "react";
import NxtbnModal from "../Modal";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main stylesheet
import 'react-date-range/dist/theme/default.css'; // theme stylesheet
import { toast } from "react-toastify";

interface NXDateRangePickerProps {
  isOpen: boolean;
  onClose: () => void;
  onDateRangeSelect: (ranges: DateRange) => void;
  onApply: (ranges: DateRange) => void;
  defaultValue?: DateRange;
}

// Define the DateRange type if not available from the library
interface DateRange {
  startDate: Date;
  endDate: Date;
  key: string;
}

function NXDateRangePicker({ isOpen, onClose, onDateRangeSelect, onApply, defaultValue }: NXDateRangePickerProps) {
  const [selectionRange, setSelectionRange] = useState<DateRange>({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
  });

  const handleSelect = (ranges: { selection: DateRange }) => {
    onDateRangeSelect(ranges.selection)
    setSelectionRange(ranges.selection);
  };

  useEffect(() =>  {
    if (defaultValue) {
      setSelectionRange(defaultValue);
    }
  }, []);

  const handleOnApply = (selectionRange: DateRange) => {
    if (!selectionRange.startDate || !selectionRange.endDate) {
      toast.error('No date range selected');
      return;
    }
    onApply(selectionRange);
    onClose();
  }


  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose} size="xxl">
      <div className="p-4 bg-white rounded-lg shadow-lg flex flex-col">
        {/* Date Range Picker */}
        <div className="flex-grow">
          <h2 className="text-lg font-semibold mb-4 text-gray-800">Select Custom Range</h2>
            <div className="w-full overflow-x-auto">
            <DateRangePicker
              ranges={[selectionRange]}
              onChange={handleSelect}
              months={2}
              direction="horizontal"
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              className="w-full"
            />
            </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-4 mt-4">
          <button
            className="px-4 py-2 text-[#0CAF60] border border-[#0CAF60]  text-sm font-medium shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 hover:bg-slate-200 rounded-md"
            onClick={onClose}
          >
            Cancel
          </button>
          <button onClick={() => {
            handleOnApply(selectionRange);
          }} className="px-4 py-2 text-white bg-[#0CAF60] hover:bg-[#098d4d] disabled:bg-[#0caf609a] text-sm font-medium rounded-md shadow-sm focus:ring-2 focus:ring-offset-2">
            Apply
          </button>
        </div>
      </div>
    </NxtbnModal>
  );
}

export default NXDateRangePicker;
